import { createRouter, createWebHistory } from "vue-router";
import authStore from "../store/auth";
import { interceptors } from "@/helpers/api";
import Dashboard from "../views/Dashboard.vue";
import Invoices from "../views/Invoices.vue";
import Reports from "../views/Reports.vue";
import Profile from "../views/Profile.vue";
import Signin from "../views/Signin.vue";

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/dashboard",
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/Invoices",
    name: "Invoices",
    component: Invoices,
  },
  {
    path: "/reports",
    name: "Reports",
    component: Reports,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {
  authStore.initialize();
  const authState = authStore.state;
  const isAuthenticated = authState.isAuthenticated;

  interceptors((error) => {
    switch (error.response.status) {
      case 401:
      case 403:
      case 404:
      case 500:
        authStore.remove();
        next({ name: "Signin" });
        break;
      default:
        next();
        break;
    }
  });

  if (to.name === "Signin" && isAuthenticated) {
    next({ name: "Dashboard" });
  } else if (to.name !== "Signin" && !isAuthenticated) {
    next({ name: "Signin" });
  } else {
    next();
  }
});

export default router;
